import { ESystemBannerType } from 'api/core';
import { useGetActiveSystemBanner } from 'api/useSystemBannersApi';
import {
  AlertTriangleIcon,
  CheckCircleIcon,
  CircleAlertIcon,
  InfoIcon,
  XCircleIcon,
} from 'lucide-react';
import { twMerge } from 'tailwind-merge';

export const SystemBanner = () => {
  const { data: activeBanner } = useGetActiveSystemBanner();
  const systemBanner = activeBanner?.systemBanner;

  if (!systemBanner) return null;

  const icon = getBannerIcon(systemBanner.type);

  return (
    <div className="w-full flex justify-center">
      <div
        role="alert"
        className={twMerge(
          'alert items-center gap-3 px-4 py-2 shadow-md text-white rounded-md max-w-lg w-full',
          systemBanner.type === ESystemBannerType.Information && 'alert-info',
          systemBanner.type === ESystemBannerType.Warning && 'alert-warning',
          systemBanner.type === ESystemBannerType.Error && 'alert-error',
          systemBanner.type === ESystemBannerType.Success && 'alert-success'
        )}
      >
        {icon}
        <div className="flex flex-col min-w-0">
          <h3 className="font-bold">{systemBanner.title}</h3>
          <p
            className="[&>a]:underline"
            dangerouslySetInnerHTML={{ __html: systemBanner.description }}
          />
        </div>
      </div>
    </div>
  );
};

const getBannerIcon = (type: ESystemBannerType) => {
  const baseClass = 'w-6 h-6';
  switch (type) {
    case ESystemBannerType.Information:
      return <InfoIcon className={baseClass} />;
    case ESystemBannerType.Warning:
      return <AlertTriangleIcon className={baseClass} />;
    case ESystemBannerType.Error:
      return <XCircleIcon className={baseClass} />;
    case ESystemBannerType.Success:
      return <CheckCircleIcon className={baseClass} />;
    default:
      return <CircleAlertIcon className={baseClass} />;
  }
};
